import { Card, CardContent, Grid } from "@mui/material";
import { OneColumn, PRNumberField, Capacity } from "@soqs/common";

import React from "react";
import { useForm } from "react-final-form";
import FraudEmailFieldComponent from "./usercomponents/FraudEmailFieldComponent";
import FraudPhoneFieldComponent from "./usercomponents/FraudPhoneFieldComponent";
import FraudName from "./usercomponents/FraudName";

const TaxpayerDetails = (_props) => {
  const formstate = useForm();
  return (
    <Grid size={{ xs: 12 }}>
      <Card>
        <CardContent>
          <Grid container columnSpacing={1.5} rowSpacing={0.5}>
            {formstate.values?.capacity === Capacity.TaxPractitioner ? (
              <OneColumn>
                <PRNumberField />
              </OneColumn>
            ) : null}
            {formstate.values?.capacity === Capacity.TaxPractitioner ? (
              <OneColumn />
            ) : null}
            <OneColumn>
              <FraudName
                label="First Name"
                name="reportingname"
                required={true}
              />
            </OneColumn>
            <OneColumn>
              <FraudName
                label="Surname"
                name="reportingsurname"
                required={true}
              />
            </OneColumn>

            <OneColumn>
              <FraudPhoneFieldComponent
                name="reportingcell"
                label="Contact Cell"
                required={
                  formstate?.getState().values?.reportingemail == null ||
                  formstate?.getState().values?.reportingemail === ""
                }
              />
            </OneColumn>
            <OneColumn>
              <FraudEmailFieldComponent
                name="reportingemail"
                label=" Contact Email"
                required={
                  formstate?.getState().values?.reportingcell == null ||
                  formstate?.getState().values?.reportingcell === ""
                }
              />
            </OneColumn>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default TaxpayerDetails;
